export default {
  AjaxRootPath: '/api',
  Storage: 'logv-',
}
